import type { AdminInspectorStatus } from '@carcheck/shared';

/**
 * Inspector FSM source-state gates for the suspend / reinstate actions
 * (AUT-125, architect guardrail 🟠 #2).
 *
 * Mirrors `forceCancellable.ts` from the orders surface: the footer button
 * "Деактивировать" is rendered only when the inspector is `active`;
 * "Восстановить" only when `suspended`. Every other status (KYC pipeline
 * states + terminal `banned`) is NOT a settable source — the FSM-only
 * statuses are driven by the verification flow, and `banned` is out of v1
 * scope on the admin SPA per the wire `ADMIN_INSPECTOR_SETTABLE_STATUSES`.
 *
 * Typed as `ReadonlySet<AdminInspectorStatus>` so adding / renaming a
 * status in `@carcheck/shared` surfaces here at typecheck, not at runtime
 * with a stale gate. Backend remains the 409 authority on transitions —
 * these helpers are pure UX.
 */
export const ADMIN_INSPECTOR_SUSPENDABLE: ReadonlySet<AdminInspectorStatus> =
  new Set<AdminInspectorStatus>(['active']);

export const ADMIN_INSPECTOR_REINSTATEABLE: ReadonlySet<AdminInspectorStatus> =
  new Set<AdminInspectorStatus>(['suspended']);

export const canSuspend = (status: AdminInspectorStatus): boolean =>
  ADMIN_INSPECTOR_SUSPENDABLE.has(status);

export const canReinstate = (status: AdminInspectorStatus): boolean =>
  ADMIN_INSPECTOR_REINSTATEABLE.has(status);
